var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSustainablityLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3491_9",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H60V60H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3491_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9442 9.61636C13.7802 11.2137 12.9054 12.9754 12.328 14.8182C15.1165 15.2089 17.7512 16.3732 19.8686 18.2292C26.1349 23.7217 35.5981 24.2628 42.5131 19.0474C44.1432 17.818 45.504 16.364 46.5863 14.7617C45.9945 12.9001 45.0849 11.1064 43.8535 9.45206C39.0175 2.95519 30.5647 0.681513 23.2827 3.34448",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8927 19.2471C46.3297 13.1347 39.0398 9.17715 30.8257 9.17715C28.284 9.17715 25.8309 9.55602 23.5195 10.2604",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7695 14.3291L39.2706 10.6377",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4029 9.18433L28.4217 6.55604",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1275 55.8715C15.7079 57.4 19.5127 57.657 23.043 56.8677C21.987 54.2575 21.6779 51.3937 22.2266 48.6318C23.8502 40.4588 19.587 31.9928 11.6129 28.6119C9.73309 27.8149 7.79363 27.3635 5.86485 27.2274C4.54836 28.6708 3.44985 30.3552 2.63281 32.2489C-1.28945 41.3401 2.95695 51.9566 12.1275 55.8715Z",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59503 21.2541C4.58308 28.2618 4.80058 36.5538 8.90777 43.6676C10.1787 45.8687 11.7333 47.8037 13.4991 49.4531",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4005 37.6777L5.95312 35.6253",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62535 43.1655L7.83984 47.0615",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6978 36.5151C58.2314 32.6501 56.5514 29.2264 54.1029 26.5639C52.3702 28.7834 50.0445 30.4831 47.3784 31.3889C39.4886 34.0693 34.2885 41.9942 35.3476 50.5905C35.5973 52.6169 36.176 54.5224 37.0226 56.2607C38.9307 56.6791 40.9388 56.7882 42.9873 56.549C52.8217 55.4001 59.8926 46.4144 58.6978 36.5151Z",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9844 57.748C38.5594 56.8526 45.6315 52.5182 49.7387 45.4045C51.0096 43.2033 51.908 40.8893 52.4536 38.5355",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3047 46.2426L44.251 51.9863",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4414 45.9004L53.2083 44.6327",
    stroke: "#6E9A95",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainablityLeaf);
export default __webpack_public_path__ + "static/media/sustainablity-leaf.a343814f67db8c4b49a0a9f4566b1168.svg";
export { ForwardRef as ReactComponent };